export async function notifications() {
    const [{ createRoot }, { default: React }, { toast, ToastContainer, Slide }] = await Promise.all([
        import('react-dom/client'),
        import('react'),
        import('react-toastify'),
    ]);
    // @ts-ignore
    window.levToast = toast;
    const notifications = document.createElement('div');
    document.body.append(notifications);
    const Notifications = ({ zIndex = 10000000 }) => (React.createElement(ToastContainer, {
        position: "top-right",
        autoClose: 5000,
        limit: 10,
        hideProgressBar: false,
        newestOnTop: false,
        closeOnClick: true,
        rtl: false,
        pauseOnFocusLoss: true,
        draggable: true,
        pauseOnHover: true,
        theme: "light",
        transition: Slide,
        className: "levcharity_editor_notifications_wrapper",
        progressClassName: "levcharity_editor_notification_progress",
        toastClassName: "levcharity_editor_notification",
        style: { zIndex }
    }));
    const root = createRoot(notifications);
    root.render(React.createElement(React.StrictMode, null, React.createElement(Notifications)));
}
